/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx, CSSObject } from '@emotion/react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {
  baseMarksElementsConfiguration,
  renderNodeWithEmbedConfiguration,
} from './configuration';
import { mediaQueries } from 'components/mediaQueries';
import { GuidedRecipeShort } from 'data/Article/types';
import { RichText as RichTextBody } from 'data/global/types';

const wrapperStyles = (
  additionalStyles: Props['additionalWrapperStyles'] = {},
) =>
  css({
    '> *': {
      marginBottom: '20px',
      marginTop: '20px',
    },
    '> H2': {
      marginTop: '60px',
    },
    '> H3': {
      marginTop: '40px',
    },
    overflow: 'auto',
    '& > [id]': {
      scrollMarginTop: '20px',
    },
    [mediaQueries.tablet]: {
      '& > [id]': {
        scrollMarginTop: '100px',
      },
    },

    ...additionalStyles,
  });
type Props = {
  body: RichTextBody;
  persona: string | null;
  guidedRecipes?: GuidedRecipeShort[];
  additionalWrapperStyles?: CSSObject;
};

export const RichText = ({
  body,
  persona,
  guidedRecipes,
  additionalWrapperStyles,
}: Props) => {
  const formattedText = documentToReactComponents(body.json, {
    renderNode: renderNodeWithEmbedConfiguration({
      blockEmbeds: body?.links?.entries?.block || [],
      inlineEmbeds: body?.links?.entries?.inline || [],
      persona,
      guidedRecipes,
    }),
    renderMark: baseMarksElementsConfiguration,
  });

  return (
    <article css={wrapperStyles(additionalWrapperStyles)}>
      {formattedText}
    </article>
  );
};
